<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t('add_requisition') }}</h4>
        </div>
      </div>
      <ul class="table-top-head">
        <li>
          <div class="page-btn">
            <router-link :to="{name : 'Requisition'}" class="btn btn-added">
              <span>Back</span>
            </router-link>
          </div>
        </li>
        <li>
          <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>
        </li>
      </ul>
    </div>

    <div class="card table-list-card p-3 bg-white fs-7">
    <form @submit.prevent="submitBatch" enctype="multipart/form-data">
      <!-- Header Form Section -->
      <div class="row gy-2 gx-4 mb-3 justify-content-between align-items-center">
        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("requisition_no")}}</label>
          <input type="text" class="form-control" v-model="batches.requisition_no" readonly/>
        </div>

        <div class="col-md-6 d-flex align-items-center">
          <label class="form-label small mb-0 me-3" style="width:200px;">{{$t("requisition_date")}}</label>
          <input type="date" class="form-control" v-model="batches.requisition_date" @change="fetchReceivingNo" />
          <div v-if="errors.receiving_date" class="text-danger mt-2">
            <span>{{errors.receiving_date}}</span>
          </div>
        </div>

       </div>

      <!-- Item Input Section -->
      <div class="row g-2 mb-3 align-items-start fs-7">
        <div class="col">
          <div class="position-relative">
            <!-- Search Input -->
            <input
            type="text"
            v-model="query"
            @input="debouncedSearch"
            :placeholder="$t('search_item_by_name_code')"
            class="form-control"
            @keydown="handleKeys"
          />

            <!-- Dropdown Search Results -->
            <div
              v-if="query"
              class="search-results shadow rounded bg-white position-absolute mt-2"
              style="width:450px; max-height: 450px; overflow-y: auto; z-index: 1050; border: 1px solid #e0e0e0;"
              :class="{ 'd-block': results.length > 0, 'd-none': results.length === 0 }"
            >

            <!-- Results List -->
            <ul class="list-group list-group-flush">
              <li
                v-for="(item, index) in results"
                :key="item.id"
                class="list-group-item d-flex justify-content-between align-items-center"
                :class="{ 'bg-primary text-white': index === itemIndex }"
                style="padding: 10px; font-size: 0.95rem; cursor: pointer;"
              >
                <!-- Clickable Product Info -->
                <div
                  class="flex-grow-1 d-flex flex-column"
                  @click="selectItem(item)"
                  style="cursor: pointer;"
                >
                  <div class="d-flex align-items-center gap-2">
                    <!-- Image Wrapper -->
                    <div
                      style="width:50px; height:50px; border-radius:4px; overflow:hidden; flex-shrink:0;"
                    >
                      <img
                        :src="getImageUrl(item.images && item.images.length ? item.images[0].small_thumb : null)"
                        @error="$event.target.src = getImageUrl(null)"
                        alt="Items"
                        style="width:100%; height:100%; object-fit:cover;"
                      />
                    </div>

                    <!-- Item Info -->
                    <div class="d-flex flex-column">
                      <strong class="text-dark">{{ item.item_name }} - {{ item.item_code }}</strong>
                      <span
                        style="font-size: 0.75rem; width: fit-content; color: black"
                      >
                        Stock: {{ item.stock_quantity }}
                      </span>
                      <span
                        style="font-size: 0.75rem; width: fit-content; color: black"
                      >
                        {{ $t('selling_price') }}: {{ formatMoney(item.selling_price ?? 0) }}
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- No Results -->
            <div v-if="!results.length" class="text-center text-muted py-4" style="font-size: 1rem;">
              No results found
            </div>
          </div>
          </div>
        </div>

        

        <div class="col">
          <input type="number" class="form-control" :placeholder="$t('quantity')" v-model="batches.quantity" />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.quantity">{{ errors.quantity }}</span>
          </div>
        </div>
        <div class="col">
          <FormDropdown
              v-model="batches.priority"
              :options="priorities"
              :placeholder="$t('priority')"
              clearable
            />
          <div class="text-danger mt-1" style="height:0.50em;">
            <span v-if="errors.priority">{{ errors.priority }}</span>
          </div>
        </div>

        <div class="col-auto">
          <button type="button" class="btn btn-info" @click="addItem">{{$t('add')}}</button>
        </div>
      </div>

      <!-- Items Table -->
      <div class="table-responsive mb-3 fixed-table">
        <table class="table table-bordered table-striped">
          <thead class="table-light">
            <tr>
              <th>{{ $t("item_name") }}</th>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("priority") }}</th>
              <th>{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in addedItems" :key="index">
              <td>{{ item.item_name }}</td>
              
              <td>{{ item.quantity }}</td>
              <td>{{ item.priority }}</td>
              <td>
                <button type="button" class="btn btn-sm btn-danger" @click="removeItem(index)">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </form>
  </div>

</div>
</template>

<script>
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import feather from "../../../../public/assets/js/feather.min";
import { useToast } from 'vue-toastification';
import debounce from 'lodash.debounce'
import { truncateMoney2, todayLocal } from '@/utils';

export default {
  components: {
    Vue3Datepicker,
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      batches: {
        item: null,
        quantity: null,
        requisition_no: '', 
        requisition_date: todayLocal()

      },
      items: [],
      
      errors: {},
      errorMessage: "",
      query: "",
      results: [],
      itemIndex: 0,
      selectedItem: null,
      addedItems: [],
      
      debouncedSearch: null,
      priorities:[
      	{id:'Urgent', text:'Urgent'},
      	{id:'High', text:'High'},
      	{id:'Standard', text:'Standard'},
      	{id:'Low', text:'Low'},
      ]
    };
  },

  mounted() {
    this.fetchDropdownData();
    this.fetchReceivingNo()
  },

  computed: {
    formattedItems() {
      return this.items.map(item => ({ id: item.id, text: item.item_name }));
    },
  },

  methods: {
      formatMoney(amount) {
        return truncateMoney2(amount);
      },

      async fetchDropdownData() {
        try {
          const [
            itemRes
          ] = await Promise.all([
            this.$axios.get(apiUrls.item.get),
          ]);

          this.items = itemRes?.data || [];

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      async searchItems() {
        if (!this.query) {
          this.results = []
          return
        }

        try {
          const response = await this.$axios.get(apiUrls.batch_item_search.get, {
            params: { q: this.query }
          })
          const results = response.data.results || [];
          this.results = results;
          this.itemIndex = 0;

          if (
          results.length === 1 &&
          results[0].barcode_qr_code &&
          results[0].barcode_qr_code === this.query
        ) {
          await this.selectItem(results[0])
          return
        }

          // render feather icons
          await this.$nextTick(() => {
            if (window.feather) feather.replace()
          })
        } catch (error) {
          console.error('Search error:', error)
          this.results = []
        }
      },

      selectItem(item) {
        this.selectedItem = item
        this.query = item.item_name
        this.batches.item = item.id
        this.results = []
        this.itemIndex = 0;
      },

      handleKeys(event) {
        if (event.key === 'ArrowDown') {
          this.itemIndex = Math.min(this.itemIndex + 1, this.results.length - 1);
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          this.itemIndex = Math.max(this.itemIndex - 1, 0);
          event.preventDefault();
        } else if (event.key === 'Enter') {
          const selectedProduct = this.results[this.itemIndex];
          if (selectedProduct) {
            this.selectItem(selectedProduct);
          }
          event.preventDefault();
        }
      },

      addItem() {
        if (!this.selectedItem) {
          this.toast.warning("Please select an item first.");
          return;
        }

        // Frontend validation before adding to list
        this.errors = {};
        const requiredFields = [
          "item", "quantity", "requisition_date","priority"
        ];
        requiredFields.forEach(field => {
          if (!this.batches[field]) this.errors[field] = this.$t('error.required');
        });

        if (Object.keys(this.errors).length > 0) {
          return;
        }

        // Store full batch data in addedItems
        const newItem = {
          ...this.batches,
          id: this.selectedItem.id,
          item_name: this.selectedItem.item_name,
          item_code: this.selectedItem.item_code,
          amount: (this.batches.costing_unit_price || 0) * (this.batches.quantity || 0),
          images: this.selectedItem.images || [],
        };

        this.addedItems.push(newItem);

        // Reset only row fields, not whole form structure
        this.batches = {
          item: null,
          quantity: null,
          requisition_no: this.batches.requisition_no, 
          requisition_date: this.batches.requisition_date,
        };
        this.errors = {};
        this.query = "";
        this.selectedItem = null;
      },

      getImageUrl(path) {
        const baseUrl = 'http://localhost:8000';
        const defaultImage = `${baseUrl}/media/default/default_img.jpg`;

        if (!path) return defaultImage;
        const fullpath = path.startsWith('http') ? path : `${baseUrl}${path}`;

        return fullpath || defaultImage;
      },

      async fetchReceivingNo() {
        try {
          let res = await this.$axios.get(apiUrls.purchase_rq_order_number.get, {
            params: { type: 'pr' }
          });
          this.batches.requisition_no = res.data.requisition_no;
        } catch (err) {
          console.error(err);
        }
      },

      async submitBatch() {
        if (!this.addedItems.length) {
          this.toast.warning("Please add at least one batch before submitting.");
          return;
        }


        try {
          const payload = {
            batches: this.addedItems,
          };

          // if your API expects JSON
          const response = await this.$axios.post(apiUrls.purchase_requisition.post, payload );

          this.toast.success("Requisition submitted successfully!");
          this.$router.push({name:'Requisition'});
          this.$emit("create_success");
          this.resetForm();
          this.addedItems = [];
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors;
          }
        }
      },

      cancelForm() {
        this.$router.push({name:'Requisition'});
      },

      removeItem(index) {
        this.addedItems.splice(index, 1);
      },

      resetForm() {
        // Reset form fields and errors
        this.batches = {
          item: '',
          quantity: '',
          requisition_no: '',
          requisition_date: ''
        };
        this.errors = {};
        this.errorMessage = "";
      }
    },

  watch: {

  },

  created() {
    this.debouncedSearch = debounce(this.searchItems, 300)
  },
};
</script>


<style scoped>
/* Optional: adjust table and input heights */
.table td, .table th {
  vertical-align: middle;
}

.fixed-table {
  min-height: 350px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}

/* Modal Backdrop */
.confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Modal Box */
.confirm-modal {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: fadeInScale 0.2s ease;
}

/* Header */
.confirm-header h4 {
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
}

/* Body Rows */
.confirm-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.confirm-row.due {
  color: #dc3545;
  font-weight: 600;
  font-size: 16px;
}

/* Buttons */
.confirm-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

/* Animation */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>

